// extracted by mini-css-extract-plugin
export default {"wrap":"mI-z","articleImagesWrap":"nI-z","articleImage":"oI-z","singleImage":"pI-z"};